import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React, { isValidElement } from 'react';
import { getInitialViewportSize, addViewportCallback, removeViewportCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { GridColumnPresentation } from './GridColumnPresentation.js';

var GridColumnWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(GridColumnWrapper, _React$Component);

  var _super = _createSuper(GridColumnWrapper);

  function GridColumnWrapper(props) {
    var _this;

    _classCallCheck(this, GridColumnWrapper);

    _this = _super.call(this, props);

    _this.updateViewport = function (viewport) {
      _this.setState({
        viewport: viewport
      });
    };

    _this.state = {
      viewport: getInitialViewportSize()
    };
    return _this;
  }

  _createClass(GridColumnWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addViewportCallback(this.updateViewport);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeViewportCallback(this.updateViewport);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          horizontalAlignment = _a.horizontalAlignment,
          horizontalAlignmentMd = _a.horizontalAlignmentMd,
          horizontalAlignmentSm = _a.horizontalAlignmentSm,
          horizontalAlignmentXs = _a.horizontalAlignmentXs,
          horizontalAlignFeaturePreview = _a.horizontalAlignFeaturePreview,
          otherProps = __rest(_a, ["children", "horizontalAlignment", "horizontalAlignmentMd", "horizontalAlignmentSm", "horizontalAlignmentXs", "horizontalAlignFeaturePreview"]);

      var viewport = this.state.viewport;

      if (!horizontalAlignFeaturePreview) {
        return /*#__PURE__*/React.createElement(GridColumnPresentation, Object.assign({}, otherProps, {
          horizontalAlignment: horizontalAlignment,
          horizontalAlignmentMd: horizontalAlignmentMd,
          horizontalAlignmentSm: horizontalAlignmentSm,
          horizontalAlignmentXs: horizontalAlignmentXs
        }), children);
      }

      var align = {
        xs: this.props.horizontalAlignmentXs || horizontalAlignment,
        sm: this.props.horizontalAlignmentSm || horizontalAlignment,
        md: this.props.horizontalAlignmentMd || horizontalAlignment
      }[viewport] || horizontalAlignment;
      return /*#__PURE__*/React.createElement(GridColumnPresentation, Object.assign({}, otherProps), React.Children.map(children, function (child) {
        return /*#__PURE__*/isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
          horizontalAlignment: align
        });
      }));
    }
  }]);

  return GridColumnWrapper;
}(React.Component);

export { GridColumnWrapper };
